import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { CreateDevices } from 'app/dtos/device/createDevices';
import { DeliveryDevices } from 'app/dtos/device/deliveryDeivce';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private httpClientSerivce:HttpClientService) { }

  async getAllDevices(page,size,search,companyId?:number,kindId?:number,brandModelId?:number,brandId?:number){
    const observable:Observable<any> = this.httpClientSerivce.get({
      controller:ControllerType.Device,
      queryString:`Page=${page}&Size=${size}&search=${search}&companyId=${companyId}&kindId=${kindId}&brandModelId=${brandModelId}&brandId=${brandId}`
    });
    return await firstValueFrom(observable);
  }

  async getAllCompanyDevices(page,size,search,companyId){
    const observable:Observable<any> = this.httpClientSerivce.get({
      controller:ControllerType.Device,
      queryString:`Page=${page}&Size=${size}&search=${search}&companyId=${companyId}`,
      action:"GetAllCompanyDevices"
    });
    return await firstValueFrom(observable);
  }

  async getByIdDevice(id){
    const observable:Observable<any> = this.httpClientSerivce.get({
      controller:ControllerType.Device
    },id);
    return await firstValueFrom(observable);
  }

  async createDevice(createDevices:CreateDevices){
    const observable:Observable<any> = this.httpClientSerivce.post({
      controller:ControllerType.Device
    },createDevices);
    return await firstValueFrom(observable);
  }

  async updateDevice(id,brandModelId,seriNo,period,kindId,companyId,companyPersonId,isDeviceStatus,isWarrantyStatus,description){
    const observable:Observable<any> = this.httpClientSerivce.put({
      controller:ControllerType.Device
    },
    {
      id:id,
      brandModelId:brandModelId,
      seriNo:seriNo,
      period:period,
      kindId:kindId,
      companyId:companyId,
      companyPersonId:companyPersonId,
      isDeviceStatus:isDeviceStatus,
      isWarrantyStatus:isWarrantyStatus,
      description:description
    });
    return await firstValueFrom(observable);
  }

  async deliveryDevice(deliveryDevice:DeliveryDevices){
    const observable:Observable<any> = this.httpClientSerivce.post({
      controller:ControllerType.Device,
      action:"DeliveryDevice"
    },deliveryDevice);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
